export default [{
    icon: ['left', 'fal', 'sort-size-down'],
    text: 'Refinance',
    color: 'blueish',
    value: 'refinance',
    crumb: 'Refinance'
},
{
    icon: ['left', 'fal', 'donate'],
    text: 'Lease to Own',
    color: 'green',
    value: 'lease_to_own',
    crumb: 'Lease to Own'
},
{
    icon: ['left', 'fal', 'gopuram'],
    text: 'HELOC',
    color: 'purple',
    value: 'heloc',
    crumb: 'HELOC'
},
{
    icon: ['left', 'fal', 'shopping-cart'],
    text: 'Purchase',
    color: 'orange',
    value: 'purchase',
    crumb: 'Purchase'
}];